var _defs, _g, _circle, _g2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRequests(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 885.01 898.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #eaecee;\n      }\n\n      .cls-2 {\n        fill: #6abd45;\n      }\n\n      .cls-3 {\n        fill: #3d5ba9;\n      }\n\n      .cls-4 {\n        fill: none;\n        stroke: #3d5ba9;\n        stroke-miterlimit: 10;\n        stroke-width: 39.89px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m401.33,409.42c-118.4,0-214.38,63.69-214.38,142.26v42.42c0,17.35,14.17,32.41,34.31,36.66,120.05,25.31,240.09,25.31,360.14,0,20.14-4.25,34.31-19.31,34.31-36.66v-42.42c0-78.57-95.98-142.26-214.38-142.26Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 401.33,
    cy: 269.76,
    r: 170.87
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 401.33,
    cy: 269.76,
    r: 130.67
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 401.33,
    cy: 401.33,
    r: 381.38
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 664.32,
    cy: 677.54,
    r: 220.7,
    transform: "translate(-284.52 668.19) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 664.32,
    cy: 677.54,
    r: 186.77,
    transform: "translate(-284.52 668.19) rotate(-45)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m793.81,578.5c-10.57-10.03-27.22-9.56-37.25.97l-155.91,164.18-55.48-62.94c-22.81-25.75-62.22,8.87-39.51,34.83,0,0,74.54,84.49,74.54,84.49,4.99,5.71,12.23,8.97,19.75,8.96,8.64,14.93,187.4-190.16,194.83-193.25,9.96-10.54,9.58-27.21-.98-37.23Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequests);
export default __webpack_public_path__ + "static/media/requests.876e79ed8ce66551c04dd85a5220e74b.svg";
export { ForwardRef as ReactComponent };